module.exports = __webpack_public_path__ + "static/media/bdsn1_.84fdcd89.svg";